const slickSlider = module.exports = function () {

    const $sliderTop = $('.js-slick-slider-top');
    const $firstSlider = $($sliderTop).find('.slider-item')[0];

    $($firstSlider).find('.slider-item-inner');
    $($firstSlider).find('.slider-item-inner').Lazy({ attribute: 'data-bg' });

    $sliderTop.slick({
        centerMode: true,
        centerPadding: '0',
        cssEase: 'linear',
        fade: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 7000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 500,
        prevArrow: $('.js-prev-slide-in-slider-top'),
        nextArrow: $('.js-next-slide-in-slider-top')
    });

    $($sliderTop).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        $($sliderTop).find(`div[data-slick-index="${nextSlide}"]`).find('.slider-item-inner');
        $($sliderTop).find(`div[data-slick-index="${nextSlide}"]`).find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
    });
};
